<section>
  <div *ngIf="data.block=='hasOverlappingPassportDatesError'" class="p-3">
    <div class="text-center">
      <div class="text-warning mb-2">
        <em class="fa fa-exclamation-triangle font-size-25px"></em>
      </div>
      <p class="">{{data.errorMessage}}</p>
      <button class="button1" (click)="close()"><em class="fa fa-thumbs-up fa-fw"></em>
        {{'ok'|translate}}</button>
    </div>
  </div>
  <div *ngIf="data.block=='error'" class="p-3">
    <div class="text-center">
      <div class="text-warning mb-2">
        <em class="fa fa-exclamation-triangle font-size-25px"></em>
      </div>
      <p class="">{{data.errorMessage}}</p>
      <div class="" *ngIf="data.errorReferenceNumber != null">
        <div class="text-center heading1 mb-3"> Transaction Reference Number is : <strong>{{data.errorReferenceNumber}}</strong> </div>
      </div>
      <button class="button1" (click)="close()"><em class="fa fa-thumbs-up fa-fw"></em>
        {{'ok'|translate}}</button>
    </div>
  </div>
  <div *ngIf="data.block=='notification'" class="notification px-5 py-4">
    <div class="col-12 text-center">
      <div class="text-center notification-icon mb-2"><i class="fa-solid fa-triangle-exclamation"></i></div>
      <p>{{data.message}}</p>

      <button class="button1 m-2" (click)="accept()"><em class="fa fa-check fa-fw"></em> {{'Yes' | translate}}</button>
      <button class="button2 m-2" (click)="notAccept()"><em class="fa fa-times fa-fw"></em> {{'No' |
        translate}}</button>
    </div>
  </div>
  <div *ngIf="data.block=='yesOrNo'" class="notification px-5 py-4">
    <div class="col-12 text-center">
      <p>{{data.message}}</p>

      <button class="button1 m-2" (click)="accept()"><em class="fa fa-check fa-fw"></em> {{'Yes' | translate}}</button>
      <button class="button2 m-2" (click)="notAccept()"><em class="fa fa-times fa-fw"></em> {{'No' |
        translate}}</button>
    </div>
  </div>

  <div *ngIf="data.block=='success'" class="success px-5 py-4">
    <div class="col-12 text-center">
      <div class="text-center success-icon mb-4"><i class="fa-solid fa-circle-check"></i></div>
      <p>{{data.message}}</p>

      <button class="button1 m-2" (click)="accept()">{{'ok' | translate}}</button>
    </div>
  </div>
  <div *ngIf="data.block=='notificationYesOrNO'" class="notification px-5 py-4">
    <div class="col-12 text-center">
      <p>{{data.message}}</p>

      <button class="button1 m-2" (click)="accept()"><em class="fa fa-check fa-fw"></em> {{'Yes' | translate}}</button>
      <button class="button2 m-2" (click)="notAccept()"><em class="fa fa-times fa-fw"></em> {{'No' |
        translate}}</button>
    </div>
  </div>
  <div *ngIf="data.block=='downloadQuotationProgress'" class="success p-3 px-md-5 py-md-4">
    <h4 class="heading3 mb-4 text-center">Download Quotation</h4>
    <div>
      <p class="text-center">We are currently in the process of generating your quotation document. Hang tight, it won't
        be long now! Thanks for your understanding.</p>
      <div class="text-center">
        <button class="button1 m-2" (click)="accept()">{{'ok' | translate}}</button>
      </div>
    </div>

  </div>
</section>